angular.module('rjmNg.directives').directive "exportApiKeyList", [
  () ->
    restrict: "E"
    templateUrl: "directive.exportApiKeyList.html"
    replace: true
    controllerAs: 'view'
    scope: true
    controller: [
      "logger"
      "app"
      "ExportApiKey"
      "notification"
      (logger, app, ExportApiKey, notification) ->
        view = @
        view.clientId = app.getClientId()
        view.client = app.getClient()

        logger.log('export api page usage', 'open', 1, 'list')

        fetchKeys = () ->
          view.loading = true
          ExportApiKey.query({clientId: view.clientId}).$promise.then(
            ((data) ->
              view.loading = false
              view.keys = data
            ),
            ( () ->
              view.loading = false
            )
          )

        fetchKeys().then((->), (-> view.error = "Error loading Export API keys. Please contact support."))

        view.DEFAULT_IP = '127.0.0.1'

        # only one key should be edited at a time
        editingKey = null
        view.editKey = (key) -> editingKey = key
        view.editingKey = (key) -> editingKey is key

        view.createKey = () ->
          newKey = new ExportApiKey()
          newKey.$save({clientId: view.clientId}).then () ->
              notification.success(
                "API key creation successful",
                "Successfully created Export API key.",
                "export-api",
                null,
                3
              )
              fetchKeys()
              logger.log('export api key created', 'create', 1, newKey.key)
            , () ->
              notification.error(
                "API key creation failed",
                "Failed to create Export API key.",
                "export-api",
                null,
                3
              )
              fetchKeys()

        view.deleteKey = (key) ->
          view.delkey = key.key # Save this for logging
          key.$delete({clientId: view.clientId, id: key.id}).then () ->
              notification.success(
                "API key deletion successful",
                "Successfully deleted Export API key.",
                "export-api",
                null,
                3
              )
              logger.log('export api key deleted', 'delete', 1, view.delkey)
              delete view.delkey # Clean up
              fetchKeys()
            , () ->
              notification.error(
                "API key deletion failed",
                "Failed to delete Export API key.",
                "export-api",
                null,
                3
              )
              fetchKeys()

        view.updateKey = (key) ->
          if(view.ipsAreUnique(key))
            key.ips = (ip for ip in key.ips when ip )  # flatten ip objects
            key.$save({clientId: view.clientId, id: key.id}).then () ->
                notification.success(
                  "API key update successful",
                  "Successfully updated Export API key IPs.",
                  "export-api",
                  null,
                  3
                )
                fetchKeys()
                logger.log('export api key updated', 'update', 1, key.key)
              , (resp) ->
                view.error = ""
                notification.error(
                  "API key update failed.",
                  "Failed to update IPs for Export API key. #{resp.data.error}",
                  "export-api",
                  null,
                  5
                )
                fetchKeys()
          else
            notification.error(
                  "API key update failed.",
                  "Failed to update IPs for Export API key. IP's in a key must be unique.",
                  "export-api",
                  null,
                  5
                )

        view.cancelUpdate = (key) ->
          fetchKeys()

        # Remove an IP from a key
        view.removeIP = (key, index) ->
          key.ips.splice index, 1

        # Make sure all of the IP's in a key are unique
        view.ipsAreUnique = (key) ->
          if _.uniq(key.ips).length < key.ips.length then return false
          return true

        # Check if an IP at a given index is a repeat of an earlier IP
        view.isRepeatIP = (key, index) ->
          repeat = (ip for ip in key.ips.slice(0,index) when ip == key.ips[index]).length > 0
          return repeat

        view
    ]
]
